import { UserOrgsStore } from "src/store";

import { createSerializer } from "./serializer";

const UserOrgsSerializer = createSerializer({ store: UserOrgsStore });

export { UserOrgsSerializer };
